import { GET_ALERTS, GET_ALERT } from './../constants/actionTypes'
import get from 'lodash/get'

const alerts = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_ALERTS: {
      const page = get(action, 'data.pageInfo', {})
      const alerts =
        page.page === 1
          ? get(action, 'data.gangwayAlerts', [])
          : [
              ...get(store, 'alerts', []),
              ...get(action, 'data.gangwayAlerts', [])
            ]
      return {
        page,
        alerts
      }
    }
    default:
      return store
  }
}

const alert = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_ALERT:
      return action.data
    default:
      return store
  }
}

export { alerts, alert }
